import { getTelemetryConfig } from "./telemetryConfig";

const recentEvents = new Map();

export function shouldDedupeTelemetryEvent(eventName, dedupeKey) {
  if (!dedupeKey) {
    return false;
  }

  const key = `${eventName}:${dedupeKey}`;
  const now = Date.now();
  const { dedupeWindowMs } = getTelemetryConfig();
  const previous = recentEvents.get(key);

  if (previous && now - previous < dedupeWindowMs) {
    return true;
  }

  recentEvents.set(key, now);

  if (recentEvents.size > 500) {
    for (const [storedKey, timestamp] of recentEvents.entries()) {
      if (now - timestamp > dedupeWindowMs) {
        recentEvents.delete(storedKey);
      }
    }
  }

  return false;
}

export function resetTelemetryDeduperForTests() {
  recentEvents.clear();
}
